function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M13.697 12l5.128-5.128 1.058-1.057a.403.403 0 000-.566L18.75 4.117a.4.4 0 00-.566 0L12 10.303 5.814 4.117a.4.4 0 00-.565 0L4.117 5.249a.4.4 0 000 .565L10.303 12l-6.186 6.185a.4.4 0 000 .566l1.131 1.131a.4.4 0 00.566 0L12 13.698l5.128 5.128 1.057 1.058c.156.155.41.155.566 0l1.131-1.132a.4.4 0 000-.566L13.698 12z"
});

function SvgCloseinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgCloseinline;